export const ALL_VALID_IMAGE_TYPES = ['png', 'jpg', 'jpeg', 'webp'];